module.exports = __webpack_public_path__ + "static/kick-ass-biscuits.49bee86c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/kick-ass-biscuits.png
// module id = 133
// module chunks = 35783957827783 36733297554888